import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2, Compass } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-slate-950 text-slate-400" data-testid="auth-loading">
        <div className="flex items-center gap-3">
          <Compass className="h-5 w-5 text-amber-500" />
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="font-mono text-xs uppercase tracking-widest">Checking session…</span>
        </div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
}
